import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ant-image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "ant-image-preview-root"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-image-preview-mask" }, null, -1)
const _hoisted_5 = { class: "ant-image-preview" }
const _hoisted_6 = { class: "ant-image-preview-content" }
const _hoisted_7 = { class: "ant-image-preview-body" }
const _hoisted_8 = { class: "ant-image-preview-operations" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "close",
  class: "anticon anticon-close ant-image-preview-operations-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "close",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" })
  ])
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "zoom-in",
  class: "anticon anticon-zoom-in ant-image-preview-operations-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "zoom-in",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "zoom-out",
  class: "anticon anticon-zoom-out ant-image-preview-operations-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "zoom-out",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" })
  ])
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "rotate-right",
  class: "anticon anticon-rotate-right ant-image-preview-operations-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "rotate-right",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" })
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "rotate-left",
  class: "anticon anticon-rotate-left ant-image-preview-operations-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "rotate-left",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" })
  ])
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "ant-image-img",
        src: _ctx.src,
        style: _normalizeStyle({
        width: _ctx.imageWidth,
        height: _ctx.imageHeight
      }),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePreview && _ctx.handlePreview(...args)))
      }, null, 12, _hoisted_2)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              class: "ant-image-preview-wrap",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      _createElementVNode("li", {
                        class: "ant-image-preview-operations-operation",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)), ["stop"]))
                      }, _hoisted_10),
                      _createElementVNode("li", {
                        class: "ant-image-preview-operations-operation",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleZoomOut && _ctx.handleZoomOut(...args)), ["stop"]))
                      }, _hoisted_12),
                      _createElementVNode("li", {
                        class: _normalizeClass(["ant-image-preview-operations-operation", {
                    'ant-image-preview-operations-operation-disabled': !_ctx.ableToZoomIn
                  }]),
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleZoomIn && _ctx.handleZoomIn(...args)), ["stop"]))
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        class: "ant-image-preview-operations-operation",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRotateRight && _ctx.handleRotateRight(...args)), ["stop"]))
                      }, _hoisted_16),
                      _createElementVNode("li", {
                        class: "ant-image-preview-operations-operation",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRotateLeft && _ctx.handleRotateLeft(...args)), ["stop"]))
                      }, _hoisted_18)
                    ]),
                    _createElementVNode("div", {
                      class: "ant-image-preview-img-wrapper",
                      style: _normalizeStyle({
                  transform: `translate(${_ctx.translate.x}px, ${_ctx.translate.y}px)`
                })
                    }, [
                      _createElementVNode("img", {
                        class: "ant-image-preview-img",
                        draggable: "false",
                        src: _ctx.src,
                        style: _normalizeStyle({
                    transform: `scale(${_ctx.zoom}) rotate(${_ctx.rotate}deg)`
                  }),
                        onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleMouseDown($event)), ["stop"])),
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.preview = true), ["stop"]))
                      }, null, 44, _hoisted_19)
                    ], 4)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}